import React from 'react';
import { useNavigate } from "react-router-dom";
import './barraPasos.scss';

export const BarraPasos = () => {
    let navigate = useNavigate();
    let goBack = () => {
        navigate(-1);
    };

    const seccionPlanesExistente = document.querySelector('.seccion_planes');
    const numeroDePaso = seccionPlanesExistente ? 1 : 2;

    return (
        <div className="barra_pasos">
            <div className="container">
                <div className="volver" onClick={goBack}>
                    <div className="ico"></div>
                    <span>Volver</span>
                </div>
                <div className="m_steps">
                    Paso <span>{numeroDePaso}</span> de <span>2</span>                       
                </div>
                <div class={`pasos paso_1 ${numeroDePaso === 1 ? 'activo' : ''}`}>
                    <span>1</span>
                    Planes y coberturas
                </div>

                <div className="line line_completed"></div>

                <div class={`pasos paso_2 ${numeroDePaso === 2 ? 'activo' : ''}`}>
                    <span>2</span>
                    Resumen
                </div>
            </div>                
        </div>	
    )
}
